import { render } from "./SubCategoriesNav.vue?vue&type=template&id=bd59cd18"
import script from "./SubCategoriesNav.vue?vue&type=script&lang=js"
export * from "./SubCategoriesNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__